import React, { useEffect, useState } from 'react';
import {
  CarouselProvider,
  Slide,
  Slider,
  ButtonBack,
  ButtonNext,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import {
  Box,
  Chip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from 'views/StudentContent/components/Header';
import { NEWSLETTER_STATUS } from 'helpers/newsletter';
import { useStyles } from './styles';

export default ({ newsletters }) => {
  const classes = useStyles();
  const size = useWindowSize();
  const theme = useTheme();
  const { t } = useTranslation(['newsletter']);
  const [visibleSlides, setVisibleSlides] = useState(1);
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });

  useEffect(() => {
    const available = isDesktop ? size.width - 336 : size.width;
    setVisibleSlides(Math.max(1, Math.trunc(available / 200)));
  }, [size, isDesktop]);

  if (!newsletters.length) return null;

  return (
    <div className={classes.root}>
      <CarouselProvider
        visibleSlides={visibleSlides}
        totalSlides={newsletters.length}
        naturalSlideWidth={50}
        naturalSlideHeight={50}
        className={classes.carrossel}
      >
        {newsletters.length > visibleSlides && (
          <>
            <ButtonBack className={classes.buttons} style={{ left: -22 }}>
              <ArrowBackIos />
            </ButtonBack>

            <ButtonNext className={classes.buttons} style={{ right: -22 }}>
              <ArrowForwardIos />
            </ButtonNext>
          </>
        )}

        <Slider tabIndex={-1} className={classes.slideContainer}>
          {newsletters.map((newsletter, index) => (
            <Slide tabIndex={-1} index={index} key={newsletter.id}>
              <Box>
                <Link
                  tabIndex={0}
                  to={`/newsletter/${newsletter.id}`}
                  className={classes.slideCard}
                >
                  <div
                    className={classes.image}
                    style={
                      newsletter.cover?.url
                        ? { backgroundImage: `url("${newsletter.cover.url}")` }
                        : undefined
                    }
                  >
                    {newsletter.status === NEWSLETTER_STATUS.draft && (
                      <Chip
                        size="small"
                        className={classes.draft}
                        label={t('newsletter:status.draft')}
                      />
                    )}
                  </div>
                  <Typography className={classes.text}>
                    {newsletter.title}
                  </Typography>
                </Link>
              </Box>
            </Slide>
          ))}
        </Slider>
      </CarouselProvider>
    </div>
  );
};
